
export default {
  props: {
    links: { type: Array, default: () => [] },
    keyPrefix: { type: String, required: true },
  },
};
